import {
    AnimationBaseController,
    GameApiBase
} from "@denishussar/html5-game-engine";
import {Inject} from "@denishussar/html5-game-engine";
import {IAnimationControllerConfiguration} from "@denishussar/html5-game-engine";
import {GameModel} from "../../../Models/GameModel";
import {AnimationContents} from "../../AnimationContents";
import {GameLogic} from "../../../Logic/GameLogic";

import {ButtonController, IButtonControllerOptions} from "../../Common/ButtonController";

export interface IIntroScreenControllerOptions
{
}

export class ExitGameScreenController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options:IIntroScreenControllerOptions,
                       @Inject private _gameLogic: GameLogic,
                       @Inject private _arenaApi: GameApiBase) {
        super("ExitGameScreenController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.PAUSE_SCREEN_JSON,
            libraryName: "exit_game",
            childControllers: {
                YesButton: {
                    instanceName: "btn_yes",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{
                            this._gameLogic.hidenModal();
                            console.log("yes button click");
                        }
                    }
                },
                NoButton: {
                    instanceName: "btn_no",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{
                            console.log("no button click");
                        }
                    }
                },
            },
            modelWatch: {
                
            }
        };
    }

    protected onInitialize(): void {
      console.log('Pause');
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }

}

